module.exports = __webpack_public_path__ + "svg/welcome.47588159149c3bf3f2e109a0f4ebfaeb.svg";